module.exports = __webpack_public_path__ + "static/media/clock_old.576e24e1.svg";